import { Injectable } from '@angular/core';
import {
  iconActions,
  iconAddAddress,
  iconAddressBook,
  iconAlert,
  iconArrowPanel,
  iconBloodCreatinine,
  iconBloodUrea,
  iconBoth,
  iconCalculator,
  iconCalendar,
  iconCalendarSmall,
  iconCat,
  iconCatBcs1Large,
  iconCatBcs1Medium,
  iconCatBcs2Large,
  iconCatBcs2Medium,
  iconCatBcs3Large,
  iconCatBcs3Medium,
  iconCatBcs4Large,
  iconCatBcs4Medium,
  iconCatBcs5Large,
  iconCatBcs5Medium,
  iconCatBcs6Large,
  iconCatBcs6Medium,
  iconCatBcs7Large,
  iconCatBcs7Medium,
  iconCatBcs8Large,
  iconCatBcs8Medium,
  iconCatBcs9Large,
  iconCatBcs9Medium,
  iconCatBcsPlaceholderLarge,
  iconCatBcsPlaceholderMedium,
  iconCheckmark,
  iconChevronDown,
  iconClose,
  iconDelete,
  iconDocuments,
  iconDog,
  iconDogBcs1Large,
  iconDogBcs1Medium,
  iconDogBcs2Large,
  iconDogBcs2Medium,
  iconDogBcs3Large,
  iconDogBcs3Medium,
  iconDogBcs4Large,
  iconDogBcs4Medium,
  iconDogBcs5Large,
  iconDogBcs5Medium,
  iconDogBcs6Large,
  iconDogBcs6Medium,
  iconDogBcs7Large,
  iconDogBcs7Medium,
  iconDogBcs8Large,
  iconDogBcs8Medium,
  iconDogBcs9Large,
  iconDogBcs9Medium,
  iconDogBcsPlaceholderLarge,
  iconDogBcsPlaceholderMedium,
  iconEdit,
  iconEmptyStateDesktop,
  iconEmptyStateMobile,
  iconExclamation,
  iconExternalLink,
  iconFemale,
  iconFood2,
  iconFood3,
  iconGrid,
  iconIndoor,
  iconInfo,
  iconLightBulb,
  iconLink,
  iconList,
  iconLoading,
  iconLogoWithText,
  iconMale,
  iconMinus,
  iconNoProducts,
  iconOutdoor,
  iconPlus,
  iconProductSearch,
  iconRangeBhn,
  iconRangeCcn,
  iconRangeFbn,
  iconRangeShn,
  iconRefresh,
  iconSearch,
  iconShop,
  iconSpecieCat,
  iconSpecieDog,
  iconSpecificGravity,
  iconTerritoryBirthAndGrowth,
  iconTerritoryDermatology,
  iconTerritoryGastrointestinalTract,
  iconTerritoryHealthManagement,
  iconTerritoryUrinary,
  iconTerritoryVitalSupport,
  iconTerritoryWeightManagement,
  iconToolDaActive,
  iconToolMufActive,
  iconToolRdActive,
  iconToolSrActive,
  iconToolFrActive,
  iconToolWmActive,
  iconTrash,
  iconUnlink,
  iconWarning,
  iconWeightLossProgram,
  iconWetProducts,
  iconSpinnerCircle,
  iconSuccess,
  iconArrowGo,
  iconFail,
  iconPrice16,
  iconPrice24,
  iconShop16,
  iconNewWindow16,
  iconSuccess32,
  iconView,
  iconHide,
  iconTick,
  iconWarningCross,
  iconPetChart,
  iconCentils,
  iconWeight,
  iconFilter,
  iconTerritorySportingLife,
  iconSimplePlus,
  iconSimpleMinus,
  iconSearch32,
  iconTreats,
  iconFail32,
  iconCart,
  Icon,
  iconInformation,
  iconQrCode,
  iconDownload,
  iconAddressBook2,
  iconPrice,
  iconLifeSaver,
} from './icons';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  private registry = new Map<string, string>();

  constructor() {
    this.registerIcons([
      iconActions,
      iconAlert,
      iconAddressBook,
      iconAddressBook2,
      iconBloodCreatinine,
      iconBloodUrea,
      iconBoth,
      iconCalculator,
      iconCat,
      iconCheckmark,
      iconChevronDown,
      iconClose,
      iconDelete,
      iconDocuments,
      iconDog,
      iconEmptyStateDesktop,
      iconEmptyStateMobile,
      iconFemale,
      iconGrid,
      iconInfo,
      iconInformation,
      iconIndoor,
      iconLifeSaver,
      iconLink,
      iconList,
      iconLightBulb,
      iconMale,
      iconMinus,
      iconSpecieDog,
      iconSpecieCat,
      iconPlus,
      iconOutdoor,
      iconAddAddress,
      iconShop,
      iconSpecificGravity,
      iconUnlink,
      iconWarning,
      iconWetProducts,
      iconWeightLossProgram,
      iconProductSearch,
      iconRangeBhn,
      iconRangeCcn,
      iconRangeFbn,
      iconRangeShn,
      iconRefresh,
      iconEdit,
      iconFood2,
      iconFood3,
      iconCart,
      iconCatBcs1Large,
      iconCatBcs2Large,
      iconCatBcs3Large,
      iconCatBcs4Large,
      iconCatBcs5Large,
      iconCatBcs6Large,
      iconCatBcs7Large,
      iconCatBcs8Large,
      iconCatBcs9Large,
      iconDogBcs1Large,
      iconDogBcs2Large,
      iconDogBcs3Large,
      iconDogBcs4Large,
      iconDogBcs5Large,
      iconDogBcs6Large,
      iconDogBcs7Large,
      iconDogBcs8Large,
      iconDogBcs9Large,
      iconCatBcsPlaceholderLarge,
      iconDogBcsPlaceholderLarge,
      iconCatBcs1Medium,
      iconCatBcs2Medium,
      iconCatBcs3Medium,
      iconCatBcs4Medium,
      iconCatBcs5Medium,
      iconCatBcs6Medium,
      iconCatBcs7Medium,
      iconCatBcs8Medium,
      iconCatBcs9Medium,
      iconDogBcs1Medium,
      iconDogBcs2Medium,
      iconDogBcs3Medium,
      iconDogBcs4Medium,
      iconDogBcs5Medium,
      iconDogBcs6Medium,
      iconDogBcs7Medium,
      iconDogBcs8Medium,
      iconDogBcs9Medium,
      iconCatBcsPlaceholderMedium,
      iconDogBcsPlaceholderMedium,
      iconTrash,
      iconCalendar,
      iconExclamation,
      iconSearch,
      iconSearch32,
      iconArrowPanel,
      iconCalendarSmall,
      iconLoading,
      iconTerritoryWeightManagement,
      iconTerritoryBirthAndGrowth,
      iconTerritoryDermatology,
      iconTerritoryGastrointestinalTract,
      iconTerritoryHealthManagement,
      iconTerritoryUrinary,
      iconTerritoryVitalSupport,
      iconTerritorySportingLife,
      iconToolDaActive,
      iconToolSrActive,
      iconToolFrActive,
      iconToolWmActive,
      iconToolRdActive,
      iconToolMufActive,
      iconTreats,
      iconExternalLink,
      iconNoProducts,
      iconLogoWithText,
      iconPlus,
      iconMinus,
      iconSimplePlus,
      iconSimpleMinus,
      iconSpinnerCircle,
      iconSuccess,
      iconSuccess32,
      iconFail,
      iconFail32,
      iconArrowGo,
      iconPrice,
      iconPrice16,
      iconPrice24,
      iconShop16,
      iconNewWindow16,
      iconView,
      iconHide,
      iconTick,
      iconWarningCross,
      iconWarning,
      iconPetChart,
      iconCentils,
      iconWeight,
      iconFilter,
      iconQrCode,
      iconDownload,
    ]);
  }
  /**
   * Register icons to the registry
   */
  public registerIcons(icons: Icon[]): void {
    icons.forEach((icon: Icon) => this.registry.set(icon.name, icon.data));
  }
  /**
   * Get icon from registry
   */
  public getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      console.warn(`We could not find the Icon with the name ${iconName}, did you add it to the registry?`);
    }
    return this.registry.get(iconName);
  }
}
